
//Constants for the view types on frontend.

//For the homepage view.
export const HOME_PAGE = "HOME_PAGE";
export const HOME = "Home";
export const BUSINESS_INSIGHTS_PAGE = "Business Insights";
export const DOCUMENT_QUERY_PAGE = "Document Query";
export const TRANSCRIPT_ANALYZER_PAGE = "Transcript Analyzer";
export const AI_DASHBOARDS_PAGE = "Dashboard";
export const COLLABORATION_PAGE = "Collaboration";
export const FEEDBACK_PAGE = "Feedback";


export const AI_AGENTS_PAGE = "AI Agents";
export const INSIGHT_AGENT_PAGE = "Insight Agent";
export const APIS_PAGE = "APIs";
export const MONITORING_PAGE = "Monitoring";
export const LOGS_PAGE = "Logs";
export const CHAT = "New Chat";
export const CHAT_HISTORY = "History";
export const ARTIFACTS_PAGE = "Artifacts";
export const PINBOARD_PAGE = "Studio";

export const TOOLS_PAGE = "Tools";
export const KNOWLEDGE_PAGE = "Knowledge";
export const DOMAIN_STORES = "Domain Stores";
export const BUSSINESS_GLOSSARY = "Business Glossary";
export const INTEGRATION_PAGE = "Integration";
export const BUSINESS_ANALYST = "Business Analyst";
export const SUPER_ADMIN = "Super Admin";
export const WORKSPACE_OWNER = "Workspace Owner";

export const ERROR_BOUNDARY_MSG = "ERROR_BOUNDARY_MSG";

export const TTYD_3 = 'TTYD_3';

export const ERROR_DISABLE_HEADING ="Uh-Oh! Looks like the access to this application is disabled."
export const ERROR_SOMETIMES = "Kindly login after sometime."
export const ERROR_DISABLE_ACCESS = "Uh-Oh! Looks like you don't have permission to access this section"
export const ERROR_DISABLE_CONSTANT = "We're sorry, but you have not been added to any project. Please contact your administrator to request access."

export const LOGOUT = "Logout";
export const COMPANY = "Company";
export const WORKSPACE = "Workspace";
export const SWITCH_VIEW = "Switch View";
export const CHANGE = "Change";
export const SAVE_CHANGES = "Save Changes";

 
